var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import Select from "./Select";
import { FormMessage, SelectGroup, Label, HintText } from "../../Form";
var SelectControl = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, placeholder = _a.placeholder, options = _a.options, _b = _a.disabled, disabled = _b === void 0 ? false : _b, label = _a.label, hintText = _a.hintText, message = _a.message, state = _a.state, className = _a.className, maxWidth = _a.maxWidth, style = _a.style, otherProps = __rest(_a, ["id", "name", "placeholder", "options", "disabled", "label", "hintText", "message", "state", "className", "maxWidth", "style"]);
    var ariaDescribedBy = state ? "".concat(id, "-desc") : undefined;
    return (React.createElement(SelectGroup, { state: disabled ? "disabled" : state },
        React.createElement(Label, { htmlFor: id },
            label,
            hintText && React.createElement(HintText, null, hintText)),
        React.createElement(Select, __assign({}, otherProps, { ref: ref, id: id, name: name, disabled: disabled, placeholder: placeholder, options: options, maxWidth: maxWidth, "aria-describedby": ariaDescribedBy, className: className, style: style })),
        message && state && !disabled && (React.createElement(FormMessage, { id: "".concat(id, "-desc"), state: state }, message))));
});
export default SelectControl;
